// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"007abafb","110":"e049bf77","150":"6274b959","307":"6df13035","372":"356599d1","443":"d3c469f7","453":"8ab44547","532":"ff42685f","764":"72a9063e","799":"37db3fe4","827":"1cb9615a","855":"649d4edf","918":"b23aa48e","921":"6acb6e92"}[chunkId] + ".chunk.js";
};